import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { find, noop } from 'lodash';

import { View } from '@dbk/ui-react-utils';
import Text, { H1 } from '@dbk/ui-text';
import Dropdown from '@dbk/ui-dropdowns';
import BlurModal from '../../../../src/components/common/blur-modal';
import LoginInput from './login.input';
import withExtraProps from '../../../common/components/utils/with-extra-props';
import InfoMessage from '../../../components/info-message';
import './login.css';
import languageData from '../../../data/language-list.json';
import { REGION, LANGUAGES, LANGUAGE_SHORT_CODE, PDF_NAME, LINKS_NAME, KEY_CODE, FSCS_LOGO_URL, RM_REGION_UK } from '../../../constants';
import { TermsConditions, SignUp, PdfContent, RegisterNewDevice as RegisterDevice} from '../../../../src/screens/modal-content';
import ForgotPasswordPage from '../../auth/forgot-password';
import ForgotPasswordModalContent from '../../../../@extension/CH/src/screens/auth/forgot-password/forgot-password-modal-content';
import { PALETTE } from '../../../constants';
import { EBANKINGWEBLUX, EBANKINGWEBUK } from '../../../constants';
import envConfig from '../../../../db-env-build';
import TermsConditionLUX from '../../modal-content/lux-modals-for-login';
import { downloadPdf } from '../../../muster/utils/downloader';
import config from '../../../data/settings.json';
import Modal from '@dbk/ui-modal';
import { ContactIcon, DeviceRightChoice } from '@dbk/ui-icons';
// import Button from '../../../components/common/button-view';
import Button from '@dbk/ui-buttons';
import LoginHeader from './login.header';
import { DbLogoText, DbText } from '../../../components/common/icons';
import createHistory from 'history/createBrowserHistory'
import NtbModal from '../../auth/ntb-modal/ntb-modal';
import RegisterNewDevice from '../../../components/common/icons/register-new-device';
import uiJson from '../../../../@extension/CH/src/data/ui.json';
import getRegionName from '../../../utils/getRegionName';
import FSCSLogo from '../../../../src/assets/svgs/Fscs-logo';
import DowntimeBanner from '../../../components/common/downtime-banner';

class LoginForm extends PureComponent {

  constructor(props) {
    super(props);
  }
  static propTypes = {
    loginTitle: PropTypes.string,
    isLoginBusy: PropTypes.bool,
    onInputChanged: PropTypes.func,
    onSignUp: PropTypes.func,
    onFaq: PropTypes.func,
    onSecurity: PropTypes.func,
    onLogin: PropTypes.func,
    onLegal: PropTypes.func,
  };

  static defaultProps = {
    loginTitle: 'Deutsche Wealth Online',
    isLoginBusy: false,
    onInputChanged: noop,
    onSignUp: noop,
    onFaq: noop,
    onSecurity: noop,
    onLogin: noop,
    onLegal: noop,
  };

  state = {
    isModalActive: false,
    key: "",
    language: "",
    langCode: "",
    isPwdModalActive: false,
    hoveredElement: null,
    visitedLink:this.props.auth.isVisitedLinkActive,
    
  }
  //WMCE-48297- To retain visited state of visited links when component is mount again

  onInputChanged = ev => {
    if (this.props.onInputChanged) {
      this.props.onInputChanged(ev);
    }
  };

  handleMouseEnter=(element)=>{
  this.setState({hoveredElement:element});
  };

  handleMouseLeave=()=>{
  this.setState({hoveredElement:null});
  };

  componentDidUpdate(){
    if(document.querySelector('.error-block')){ 
      document.querySelector('.error-block').focus();
    }
    if(document.querySelector('.info-block')){ 
      document.querySelector('.info-block').focus();
    }
    if(document.querySelector('.alertFocus')){ // for language change alert focusable
      document.querySelector('.alertFocus').focus();
    }
    if(document.querySelector('.ModalHeader span')){ // for login page popup heading focusable
      document.querySelector('.ModalHeader span').focus();
    }
  }

  convertToDropDown = values => {
    if (values && values.length) {
      if (values.length >= 1) {
        return values.map(e => ({
          label: this.props.config.regionCode === REGION.CH ? e.key : e.language,
          value: e.key,
          code: e.langCode
        }));
      }

      return values.map(e => ({
        value: e.key,
        code: e.langCode
      }));
    }
    return [];
  }

  pressedConfirm = key => {
    const languageObj = find(languageData.languageList, { key })
    const {
      languages,
      destLanguageCode
    } = this.props;
    const destLang = destLanguageCode.includes(key.toLowerCase());
    if(!destLang){
      languages.saveLanguageAtLogin({ languageObj });
    }
  };

  renderUsernamePopup = () => {

    const { i18n: { messages } } = this.props;
    return (
      <View className="row margin-top-10 padding-left-10 padding-right-20">
        <Text className="userNameFocus" size="large" tabIndex={0} aria-label={messages['app.login.username.forgot']}>{messages['app.login.username.forgot']}</Text>
        <View className="margin-top-20">
          <View className="button_container">
            <Button size="large" tabIndex="0" testID="logout_popup_no_button" id="logout_popup_no_button"
              onClick={this.hideModal}
            > {messages['app.forgotPassword.button.ok']}</Button>
          </View>
        </View>
      </View>
    )
  }

  renderFSCSLogo = () => {
    const { i18n: { messages }} = this.props;
    return (
      <div className="fscsText padding-top-20">
                <span className="margin-top-20">
                  <a rel="noopener" href={FSCS_LOGO_URL} target="_blank" aria-label={messages['app.login.accessibility.link.fscs'] + messages['app.payment.fscsLogo.text']}>
                    <FSCSLogo />
                    <Text secondary className='logoText'>{messages['app.payment.fscsLogo.text']}</Text>
                  </a>
                </span>
    </div>
    );
  };

  navigateToLogin = () => {
    this.setState(() => ({
      isPwdModalActive: false
    }));
    const history = createHistory();
    history.go(0);
  }

  modalContent() {
    const { modalContentType } = this.state;
    const { i18n: { messages }, languages: { destLanguageCode } } = this.props;

    switch (modalContentType) {
      case 'forgot-password':
        return <ForgotPasswordModalContent navigateToLogin={this.navigateToLogin}/>
      case 'username':
        return this.renderUsernamePopup();
      case 'first-time-login'  :
        return <PdfContent modalContentType="first-time-login" />;
      case 'mobile-app-guide':
        return <NtbModal closeModal={this.hideModal} isMobileGuide/>
      case 'register-new-device':
          return <RegisterDevice messages={messages} destLanguageCode={destLanguageCode} closeModal={this.hideModal}/>;
      case 'legal':
        if (envConfig.envConfig !== EBANKINGWEBLUX) {
          return <TermsConditions />;
        } else if (envConfig.envConfig === EBANKINGWEBLUX) {
          return <TermsConditionLUX modalContentType="TnC For LUX" />
        }
      case 'sign-up':
        return <SignUp />;
      case 'faq':
        return <PdfContent modalContentType="faq" />;
      case 'security':
        return <PdfContent modalContentType="security" />;
      case 'New e-banking client':
        return <TermsConditionLUX modalContentType="New e-banking client" />
      default:
        return <View />;
    }
  }



  handleSignup = () => {
    this.toggleModal('sign-up');
  };


   handleLegal = (modalContentType) => {
    this.props.auth.setVisitedLinkActive ({...this.props.auth.isVisitedLinkActive,"TnC":true});
    this.setState((prevState)=>({visitedLink:{...prevState.visitedLink,"TnC":true}}))
    if (envConfig.envConfig === EBANKINGWEBLUX) {
      this.downloadLanguageSpecificPDF(modalContentType);
    } else {
      this.toggleModal('legal');
    }
  };

  handleAccessibilityInfoPdf = (modalContentType) => {
    this.props.auth.setVisitedLinkActive ({...this.props.auth.isVisitedLinkActive,"accessibility":true});
    this.setState((prevState)=>({visitedLink:{...prevState.visitedLink,"accessibility":true}}));
    this.downloadLanguageSpecificPDF(modalContentType);
  }

  downloadLanguageSpecificPDF = (modalContentType) => {

    const { languages: { destLanguageCode } } = this.props;
    
    const remoteUrl = window.location.href.split('ebanking')[0] + config.environments.relative.remoteUrl;
    let termsLink = "";
    let fileName = "";

    if( modalContentType === "TnC For LUX" ) {
      if(destLanguageCode === 'en-GB') {
        termsLink = remoteUrl + PDF_NAME.TERMS_CONDITION_ENGLISH;
        fileName = PDF_NAME.ONLINE_TERMS_ENGLISH;
      }
      if( destLanguageCode === 'de-CH' ) {
        termsLink = remoteUrl + PDF_NAME.TERMS_CONDITION_GERMAN;
        fileName = PDF_NAME.ONLINE_TERMS_GERMAN;
      }
    }
    if( modalContentType === "accessibility" ) {
      if(destLanguageCode === 'en-GB') {
        termsLink = remoteUrl + uiJson.pdf.accessibilityStatementEnglish;
        fileName = PDF_NAME.ACCESSIBILITY_FILE_ENG_NAME;
      }
      if( destLanguageCode === 'de-CH' ) {
        termsLink = remoteUrl + uiJson.pdf.accessibilityStatementGerman;
        fileName = PDF_NAME.ACCESSIBILITY_FILE_DEU_NAME;
      }
    }

    downloadPdf(termsLink, fileName, 'application/pdf');

  };

  toggleModal = (pageType, e) =>{
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (pageType && !e)){
      this.setState({
        isModalActive: !this.state.isModalActive,
        modalContentType: pageType,
      });
    }
  }

  togglePwdModal = (pageType) => {
    this.props.auth.setVisitedLinkActive ({...this.props.auth.isVisitedLinkActive,"password":true}); 
    this.setState((prevState)=>({visitedLink:{...prevState.visitedLink,"password":true}}))
    this.setState({
      isPwdModalActive: !this.state.isPwdModalActive,
      modalContentType: pageType,
    });
  }

  handleUserName=()=>{
  this.props.auth.setVisitedLinkActive ({...this.props.auth.isVisitedLinkActive,"username":true}); 
  this.setState((prevState)=>({visitedLink:{...prevState.visitedLink,"username":true}}))
  this.toggleModal(LINKS_NAME.USERNAME)
  }

  handleSecurityTips=(e)=>{
    if((e && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
    this.props.auth.setVisitedLinkActive ({...this.props.auth.isVisitedLinkActive,"securitytip":true});
    this.setState((prevState)=>({visitedLink:{...prevState.visitedLink,"securitytip":true}}))
    this.props.changePage('/login-security');
    }
  }

  hideModal = () => {
    this.setState(() => ({
      isModalActive: false,
      isPwdModalActive: false
    }));
    this.props.forgotPassword.resetVariables();
  };

  render() {
    let languageListArray = [];
    const { loginTitle, i18n: { messages }, languages: { destLanguage },  app: { config: { labelAccessibilityInfoEnglish, labelAccessibilityInfoGerman } }, config: { regionCode }, banner: { isDowntime } } = this.props;
    languageListArray = languageData.languageList && this.convertToDropDown(languageData.languageList)
    const languageCH = destLanguage === "English" ? "Deustche" : "English";
    const languageAPAC = destLanguage === "English" ? "ZH" : "default";
    const languageSelected = regionCode === 'CH' ? languageCH : languageAPAC;

    let headerTitle = '';
    switch (this.state.modalContentType) {
      case 'first-time-login':
        headerTitle = messages['app.login.first.time.logging'].replace("?","");
        break; 
      case 'mobile-app-guide':
          headerTitle = messages['app.login.dwo.mobile.app'];
          break;
      case 'register-new-device':
          headerTitle = messages['app.login.new.mobile.phone'];
           break;
      case 'legal':
        {
          envConfig.envConfig === EBANKINGWEBLUX ?
          headerTitle = messages['app.common.pageTitle.terms'] :
          headerTitle = messages['app.common.legal']
        }
        break;
      case 'sign-up': headerTitle = messages['app.auth.signUp.title'];
        break;
      case 'faq': headerTitle = messages['app.login.faq'];
        break;
      case 'forgot-password': headerTitle = messages['app.reset.forgotPassword.title'];
        break;
      case 'username': headerTitle = destLanguage === "English" ? `${messages['app.auth.login.forgot']}${messages['app.auth.username']}` : `${messages['app.auth.username']} ${messages['app.auth.login.forgot'].toLowerCase()}`;
        break;
      case 'security': headerTitle = messages['app.login.securityTips'];
        break;
      case 'New e-banking client': headerTitle = messages['app.auth.signUp.titleForLUX'];
        break;
      default: headerTitle = '';
        break;
    }

    const loginRegion = getRegionName();
       
    return (
      <View className="login-container">
        <View className="login__content">
          <View>
            <LoginHeader/>
            { isDowntime && <DowntimeBanner preLogin={true}/> }
            {/* <div className='login-header'>
                    <div>
                        <DbLogoText className="login__logo" />
                    </div>
                    <div className='login-header-content'>
                        <Office height={32} width={32} color={PALETTE.secondaryActive} className='margin-right-10'></Office>
                        <div className='margin-right-40 cursor-pointer' onClick={this.handleFaq}>{messages['app.login.faq']}</div>
                        <Protect height={32} width={32} color={PALETTE.secondaryActive} className='margin-right-10'></Protect>
                        <div className='margin-right-40 cursor-pointer' onClick={this.handleSecurity}>{messages['app.login.securityTips']}</div>
                        <div className="dropdown-style margin-right-40">
                            <Dropdown
                                defaultLabel
                                className="login-lang-dropdown no-hover"
                                selected={languageSelected}
                                options={languageListArray}
                                size='small'
                                onChange={option => {
                                    this.pressedConfirm(option)
                                }}
                            />
                        </div>
                    </div>
                </div> */}
            <View>
            <div className="login-body">
              <H1 tabindex={-1} className="margin-bottom-30" testID="text_loginTitle_userLogin_test" >{`${loginTitle} ${loginRegion}`}</H1>
              {/* <View className="login__ErrorBlock"><InfoMessage messages={messages} /></View> */}
              <LoginInput {...this.props} onInputChanged={this.onInputChanged} />          
                {/* <div className="dropdown-style">
                  <Dropdown
                    defaultLabel
                    className="login-lang-dropdown no-hover"
                    selected={languageSelected}
                    options={languageListArray}
                    size='small'
                    onChange={option => {
                      this.pressedConfirm(option)
                    }}
                  />
                </div> */}
              
              {/* Forgot username and password */}
              <View className="loginForm__message" >    
                {destLanguage === "English" && <Text size="large">{messages['app.auth.login.forgot']}</Text> }
                <a className={`${this.state.visitedLink["username"] ? "visited link-large" : "link-large"}`} aria-label={messages['app.login.popover.username.title']} href="javascript:;" tabIndex={0} onClick={() =>this.handleUserName()}>{messages['app.auth.username']}</a>
                <Text size="large">{messages['app.auth.login.forgot.or']}</Text>
                <a className={`${this.state.visitedLink["password"] ? "visited link-large" : "link-large"}`} aria-label={messages['app.auth.forgottenPassword.title']} href="javascript:;" tabIndex={0} onClick={() =>this.togglePwdModal(LINKS_NAME.FORGOT_PASSWORD)}>{messages['app.auth.login.forgot.pwd']}</a>
                {destLanguage === "Deutsch" && <Text size="large"> {messages['app.auth.login.forgot'].toLowerCase()}{"?"}</Text> }
              </View>
              <div aria-haspopup="true" aria-label={messages['app.login.accessibility.link.downloadApp']} className="login-body-footer cursor-pointer" onClick={() =>this.toggleModal("mobile-app-guide")} role="button" onKeyDown={(e) =>this.toggleModal(LINKS_NAME.MOBILE_APP_GUIDE, e)} tabIndex={0} onMouseEnter={()=> this.handleMouseEnter(LINKS_NAME.MOBILE_APP_GUIDE)} onMouseLeave={()=>this.handleMouseLeave()}>
                <DeviceRightChoice height={32} width={32} color={this.state.hoveredElement === "mobile-app-guide" ? PALETTE.touchableOpacityEnable : PALETTE.secondaryActive} className='margin-right-10'></DeviceRightChoice>
                <div><Text size="big" className={`${this.state.hoveredElement ==="mobile-app-guide" ? "textHoverColor" : ""}`}>{messages['app.login.dwo.mobile.app']}</Text></div>
              </div>
            
              <div aria-haspopup="true" className="login-body-footer cursor-pointer" aria-label={messages['app.login.accessibility.link.firstTimeLogin']} onClick={() =>this.toggleModal("first-time-login")} role="button" tabIndex={0} onKeyDown={(e) => this.toggleModal(LINKS_NAME.FIRST_TIME_LOGIN, e) } onMouseEnter={()=> this.handleMouseEnter(LINKS_NAME.FIRST_TIME_LOGIN)} onMouseLeave={()=>this.handleMouseLeave()}>
                <ContactIcon height={32} width={32} color={this.state.hoveredElement === "first-time-login" ? PALETTE.touchableOpacityEnable : PALETTE.secondaryActive} className='margin-right-10'></ContactIcon>
                <div><Text size="big"  className={`${this.state.hoveredElement === "first-time-login" ? "textHoverColor" : ""}`}>{messages['app.login.first.time.logging']}</Text></div>
              </div>

              <div aria-haspopup="true" aria-label={messages['app.login.accessibility.link.RegisterNewDevice']} className="login-body-footer cursor-pointer" onClick={() =>this.toggleModal("register-new-device")} role="button" tabIndex={0} onKeyDown={(e) => this.toggleModal(LINKS_NAME.REGISTER_NEW_DEVICE, e) } onMouseEnter={()=> this.handleMouseEnter("register-new-device")} onMouseLeave={()=>this.handleMouseLeave()}>
                <RegisterNewDevice height={32} width={32} color={this.state.hoveredElement === "register-new-device" ? PALETTE.touchableOpacityEnable : PALETTE.secondaryActive}></RegisterNewDevice>
                <div className='margin-left-10'><Text  size="big" className={`${this.state.hoveredElement === "register-new-device" ? "textHoverColor" : ""}`}>{messages['app.login.new.mobile.phone']}{destLanguage === "English" && "?"}</Text></div>
              </div>
              {/* <View className="login__footer">
                <View className="login__FooterItem" onClick={this.handleFaq} testID="btn_faq_userLogin_test">
                  {messages['app.login.faq']}
                </View>
                <View className="login__FooterItem--separator">|</View>
                <View className="login__FooterItem" onClick={this.handleSecurity} testID="btn_securityTips_userLogin_test">
                  {messages['app.login.securityTips']}
                </View>
              </View> */}
              { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && this.renderFSCSLogo() }
              </div>
            </View>
          </View>
          <View className="login__footer footer-container">
            <div>
              <Text size="small" tabIndex={-1}> {messages['app.login.msg']}</Text> 
              <a className={`${this.state.visitedLink["TnC"] ? "visited link-small" : "link-small" }`} href="javascript:;" aria-label={messages['app.login.accessibility.link.tnc']} tabIndex={0} onClick={() =>this.handleLegal("TnC For LUX")} id="text_termsConditions_userLogin_test">
              {/* {envConfig.envConfig === EBANKINGWEBLUX ? messages['app.login.terms&condtnForLUX']: */}
              {/* For Lux, we need to change ebanking terms & conditions to terms & conditions. */}
                {messages['app.login.terms&condtn']}
              </a> 
              <Text size="small" tabIndex={-1}>{destLanguage === "English" && messages['app.login.terms&condtn.form']}{messages['app.common.condition.text']}{destLanguage === "Deutsch" && " "}
            {this.props.i18n.messages['app.common.copyrightDisclaimer']}
            {/* {destLanguage === "English" && messages['app.security.tips.desc']}</Text> */}
             </Text>
             </div>
              <div className="loginFooterStyle">
              <a className={`${this.state.visitedLink["securitytip"] ? "visited position-relative link-small" : "position-relative link-small" }`}  href="javascript:;" tabIndex={0} aria-label={messages['app.login.accessibility.link.securityTips']} onKeyDown={(e) => this.handleSecurityTips(e)} onClick={() => this.handleSecurityTips()}>
              {messages['app.login.securityTips']}
              </a>
              {/* {destLanguage === "Deutsch" && <Text size="small" tabIndex={-1}>{messages['app.security.tips.desc']}</Text>}
              {destLanguage === "English" &&<Text size="small" tabIndex={-1}>{messages['app.auth.logoutSuccess.here']}</Text>} */}
              {/* </div> */}
            <div>
              <a className={`${this.state.visitedLink["accessibility"] ? "visited link-small" : "link-small"}`} href="javascript:;" secondary size="small" tabIndex={0} onClick={() =>this.handleAccessibilityInfoPdf("accessibility")} >
                  {destLanguage === LANGUAGES.DEUTSCH ? labelAccessibilityInfoGerman : labelAccessibilityInfoEnglish}
              </a> 
            </div>
             </div>
          </View>
        </View>
        <View>
          <BlurModal
            {...this.props}
            visible={this.state.isModalActive}
            onDone={this.hideModal}
            title={headerTitle}
            size="large"
            tabIndex={0}
            className={ this.state.modalContentType === 'mobile-app-guide' ? "ntb-modal" : "model-window-login"}
          >
            {this.modalContent()}
          </BlurModal>
            <Modal
                role="dialog"
                visible={this.state.isPwdModalActive}
                isActive={this.state.isPwdModalActive}
                onClose={this.hideModal}
                disableOutsideClick={ this.state.modalContentType === "forgot-password" }
                className="forgot_password"
                tabIndex={0}
                aria-label={headerTitle}
                title={headerTitle}
                header={
                  <div className="forgot_password">
                    <div className=" headeritem1">
                      <br/>
                    </div>
                    <div className="headeritem2">
                      <br/>
                    </div>
                  </div>
                }
                content= {this.modalContent()}
              />
        </View>
      </View >
    );
  }
}
export default withExtraProps((componentProps) => ({
  className: classNames('wrapperClass', 'someExtraClass'),
  onChange: (ev) => ({ value: ev.target.value, name: ev.target.name }),
}))(LoginForm);
